export default "__VITE_ASSET__Bm1qVudo__"